import './App.css';
import TableContextProvider from './contexts/tableContext';
import envValues from './enviornment';
import { getCookies, setCookies } from './hooks/useCookies';
import store from './redux/store';
import Routers from './router/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

function App() {
  const [showBanner, setShowBanner] = useState(true);
  const cookieBannerControl = () => {
    setShowBanner(!showBanner);
    setCookies('showCookieBanner', false);
  };
  return (
    <Provider store={store}>
      <div className="App">
        <TableContextProvider>
          <Routers />
        </TableContextProvider>
        <ToastContainer autoClose={2000} />
      </div>
      {showBanner &&
      envValues.REACT_APP_SHOW_COOKIE_BOX &&
      getCookies('showCookieBanner') !== 'false' ? (
        <div className="cookie-banner">
          <p>This website uses cookies to enhance user experience</p>
          <button type="button" className="close" onClick={cookieBannerControl}>
            I Understand
          </button>
        </div>
      ) : null}
    </Provider>
  );
}
export default App;
